import Schema from './Schema'

export default Schema
